import { useDispatch } from 'react-redux'

import { authActions } from '@/store/auth/auth.slice'
import { clientsActions } from '@/store/shop/clients/clients.slice'
import { bindActionCreators } from '@reduxjs/toolkit'

const actions = {
  ...authActions,
  ...clientsActions,
}

export const useActions = () => {
  const dispatch = useDispatch()
  return bindActionCreators(actions, dispatch)
}
